import * as React from 'react';
import { IconWrapper } from './Icon_SC';
import moon from './svgs/moon.svg';
import sun from './svgs/sun.svg';

export interface Props {
  isSun: boolean;
  onClick: () => void;
}

export const Icon: React.FC<Props> = (props) => {
  const { isSun, onClick } = props;
  return (
    <IconWrapper isSun={isSun} onClick={onClick}>
      {isSun ? <img src={sun} alt="sun" /> : <img src={moon} alt="moon" />}
    </IconWrapper>
  );
};
